import { getRequest, putRequest } from './common'

const URL_BASE = '/api/v1/console/'

export function getAllPermissions() {
  return getRequest(`${URL_BASE}permissions/`)
}

interface UpdatePermissionGroupPayload {
  name: string
  permissions: number[]
}

export function updatePermissionGroup(groupId: string, payload: UpdatePermissionGroupPayload) {
  return putRequest(`${URL_BASE}permission-groups/${groupId}/`, payload)
}
